import { loadStripe } from '@stripe/stripe-js';

interface IConfig {
  stripe_publishable_key: string;
}

declare const CONFIG: IConfig;

const STRIPE_PUBLISHABLE_KEY = CONFIG.stripe_publishable_key;

export const STRIPE = loadStripe(STRIPE_PUBLISHABLE_KEY);
